export default __webpack_public_path__ + "3fe29225e35d8001eaca0daa346fa382.png";